import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function TickIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
      >
        <path
          d="M1 6.5L6 11.5L15 1.5"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
